export default __webpack_public_path__ + "c4f4153f6fca686855b78e96ba27bba7.jpeg";